export const Images = {
    logo: require('../assets/Logo.png'),
    googleLogo: require('../assets/google.svg.png'),
    logoAndBackground: require('../assets/LogoAndBackground.png'),
    logoChallenge: require('../assets/LogoChallenge.png'),
    logoBackground: require('../assets/StockGraphBackground.png'),
    footerBackground: require('../assets/Footer.png')
};
